//react
import React from "react";
//UI components
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
//scss
import "./Modal.scss"

export const Modal = ({ handleClose, show, parent, children }) => {
	const showHideClassName = show ? "modal display-block" : "modal display-none";
	return (
		<div className={showHideClassName}>
			<section className="modalMain">
				<IconButton
					aria-label="close"
					className={"closeButton"}
					onClick={handleClose}>
					{parent !== "exitsession" ? <CloseIcon /> : null}
				</IconButton>
				{children}
			</section>
		</div>
	);
};
